export default "__VITE_PUBLIC_ASSET__9b109a84__"